import {injectGlobal} from './emotion';
import {coreColorVars} from '@packages/utilities/styled-tokens';

/**
 * injects CSS Vars at :root. *
 * @returns {Void}
 */
export const injectRootVars = (): void => {
  injectGlobal({
    ':root:not([data-wf-site])': {
      /* Inject space value */
      '--space': 4,
      /* Inject core colors */
      ...coreColorVars,
    },
  });
};
